var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar-item"},[_c('b-nav-item',{class:_vm.getClasses(),attrs:{"path":_vm.path,"to":_vm.to}},[_vm._t("item-text")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }